import { forwardRef } from 'react';
import { Slide } from '@mui/material';

const Transition = forwardRef((props, ref) => <Slide direction='up' ref={ref} {...props} />);

export default Transition;